const REQUEST_POLS = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_POLS = (state, { body }) => {
  state.Pols = body;
  state.status = "success";
};

const FAILURE_REQUEST_POLS = state => {
  state.status = "failure";
};

const REQUEST_DELETE_POL = state => {
  state.statusDelete = "fetching";
};

const SUCCESS_REQUEST_DELETE_POL = state => {
  state.statusDelete = "success";
};

const FAILURE_REQUEST_DELETE_POL = state => {
  state.statusDelete = "failure";
};

const REQUEST_UPDATE_POL = (state) => {
  state.statusUpdate = "fetching";
};

const SUCCESS_REQUEST_UPDATE_POL = state => {
  state.statusUpdate = "success";
};

const FAILURE_REQUEST_UPDATE_POL = state => {
  state.statusUpdate = "failure";
};

const REQUEST_CREATE_POL = state => {
  state.statusCreate = "fetching";
};

const SUCCESS_REQUEST_CREATE_POL = (state, { body }) => {
  state.Pol = body
  state.statusCreate = "success";
};

const FAILURE_REQUEST_CREATE_POL = state => {
  
  state.statusCreate = "failure";
};


export default {
  REQUEST_POLS,
  SUCCESS_REQUEST_POLS,
  FAILURE_REQUEST_POLS,
  REQUEST_CREATE_POL,
  SUCCESS_REQUEST_CREATE_POL,
  FAILURE_REQUEST_CREATE_POL,
  REQUEST_DELETE_POL,
  SUCCESS_REQUEST_DELETE_POL,
  FAILURE_REQUEST_DELETE_POL,
  REQUEST_UPDATE_POL,
  SUCCESS_REQUEST_UPDATE_POL,
  FAILURE_REQUEST_UPDATE_POL,

};
